import { Component, HostListener, OnInit } from '@angular/core';
import { HeaderService } from '@app/service/header/header.service';
import { StateService, ZaverProduct } from '@app/service/state/state.service';
import {
  SelectAccountData,
  UserService,
} from '@app/service/user-service/user.service';
import { ActivatedRoute, Router } from '@angular/router';
import { RouteComponent } from '@app/route/route.component';
import { Subscription } from 'rxjs';
import { QueryParamsService } from '@app/service/query-params/query-params.service';
import { DomSanitizer } from '@angular/platform-browser';
import { SeRoute } from '@assets/val/route-constants';
import { SelectorItem } from '@app/component/selector/selector.component';
import { ValuePipe } from '@app/shared/pipe/value.pipe';
enum VIEW {
  CONFIRM = 'CONFIRM',
  AIS = 'AIS',
}

@Component({
  selector: 'bank-mandate',
  templateUrl: './bank-mandate.component.html',
  styleUrls: ['../../page-shared.css', './bank-mandate.component.scss'],
})
export class BankMandateComponent extends RouteComponent implements OnInit {
  constructor(
    private userService: UserService,
    protected stateService: StateService,
    protected headerService: HeaderService,
    protected router: Router,
    protected route: ActivatedRoute,
    private sanitizer: DomSanitizer,
    private queryParamsService: QueryParamsService,
    private valuePipe: ValuePipe
  ) {
    super(router, route, stateService, headerService);
  }
  @HostListener('window:message', ['$event'])
  navigateListener($event: MessageEvent<any>) {
    if (($event as any).data.success) {
      this.navigate();
    }
  }

  useIframe: boolean;
  loading: boolean = true;
  trustlyUrl: any = false;
  pollingSubscription: Subscription;
  view: VIEW = VIEW.CONFIRM;
  VIEW = VIEW;
  ZAVERPRODUCT = ZaverProduct;
  selectorItems: SelectorItem[] = null;
  modalActive: boolean = false;

  async ngOnInit(): Promise<void> {
    const id = this.queryParamsService.getQueryParams().id;
    const selectAccountData: SelectAccountData = {
      failEndpoint: `${window.location.origin}/${SeRoute.ERROR}?id=${id}`,
      successEndpoint: `${window.location.origin}/${SeRoute.TRANSITION}?id=${id}`,
    };

    const selectAccountUrl = (
      await this.userService.selectAccount(selectAccountData).toPromise()
    ).selectAccountUrl;

    this.trustlyUrl =
      this.sanitizer.bypassSecurityTrustResourceUrl(selectAccountUrl);

    this.useIframe = true;
    this.selectorItems = [
      {
        tab: 'Ditt köp',
        title: 'Sammanfattning',
        descriptions: [{ text: this.state.paymentInformation.description }],
        lineItems: this.state.paymentInformation?.lineItems,
        totalValue: `Totalbelopp inkl. moms: ${this.valuePipe.transform(
          this.state.totalCheckoutValue
        )}`,
      },
    ];

    this.loading = false;
  }

  confirm(): void {
    this.view = VIEW.AIS;
  }

  toggleModal(): void {
    this.modalActive = !this.modalActive;
  }
}
